<template>
  <el-table :data="pileDataTable" stripe style="width: 100%" ref="pileDataTable" border
            v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="name" :label="$t('xiang-bian-ming-cheng')"></af-table-column>
    <af-table-column prop="operatorName" :label="$t('yun-ying-shang-ming-cheng')"></af-table-column>
    <af-table-column prop="stationName" :label="$t('chang-zhan-ming-cheng')"></af-table-column>
    <af-table-column prop="powerLoad" :label="$t('xiang-bian-fu-he-kw-0')"></af-table-column>
    <af-table-column :label="$t('kai-fang-zhuang-tai-0')">
      <template slot-scope="{row}">
        <div v-if="row.isOpen">
          <el-tag :type="row.isOpen | availableFilter" >
            {{ row.isOpen | YesOrNoFilter }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="showViewVisible(scope.$index, scope.row)">{{ $t('siteManager.view') }}
        </el-button>
        <el-button size="mini" @click="pileEdit(scope.$index, scope.row)">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger" @click="pileDelete(scope.$index, scope.row)">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
import i18n from "../../../../lang/index";
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      pileDataTable:{},
      listLoading:false,
    },
    filters: {
      availableFilter(code) {
        const map = {
          Y: 'success',
          N: 'danger'
        }
        return map[code]
      },
      YesOrNoFilter(code) {
        const map = {
          Y: i18n.t('kai-qi'),
          N: i18n.t('alaramMonitor.close'),
        }
        return map[code]
      },
    },
    methods:{
      showViewVisible(index,row){
        this.$emit("showViewVisible",index,row)
      },
      pileEdit(index,row){
        this.$emit("pileEdit",index,row)
      },
      pileDelete(index,row){
        this.$emit("pileDelete",index,row)
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/gunBox/list.vue